
import { Routes, Route } from 'react-router-dom';
import { useContext } from "react";
import { AppUserContext } from "../../App";
import { ErrorLoading } from "../../components/loading";
import ProjectDetails from "./project-details";
import ViewProjects from "./view-projects";
import { NewProject } from './project-manipulation';

const Projects = () => {

    const { profile } = useContext(AppUserContext);

    if (profile.permission_level > 3) {
        return <ErrorLoading>You do not have the permission to access clients.</ErrorLoading>
    }

    return (
        <Routes>
            <Route path="/" element={<ViewProjects />} />
            <Route path="/new" element={<NewProject />} />
            <Route path="/:projectid/*" element={<ProjectDetails />} />
        </Routes>
    )
}

export default Projects;